import TaskFormContainer from "../TaskFormContainer/TaskFormContainer";
import { ScrollView } from "react-native";
import AxioGeneralModal from "../../../components/axio-ds/Modal/AxioModal";

function TaskFormModalContainer({ task = undefined, journeyId = undefined, visible, onClose }) {
  return (
    <AxioGeneralModal visible={visible} onRequestClose={onClose} title={task ? "Edit To-Do" : "Create New To-Do"}>
      <ScrollView showsVerticalScrollIndicator={true} style={{ maxHeight: "100%" }}>
        <TaskFormContainer task={task} journeyId={journeyId} onComplete={onClose} />
      </ScrollView>
    </AxioGeneralModal>
  );
}

export default TaskFormModalContainer;
